<div
  *ngIf="badgeConfig"
  class="subscription-badge"
  [ngClass]="[
    'badge-' + badgeConfig.color,
    'badge-' + size,
    isLP ? 'badge-lp' : '',
    isGP ? 'badge-gp' : ''
  ]"
  [matTooltip]="badgeConfig.tooltip"
>
  <mat-icon *ngIf="badgeConfig.icon && !badgeConfig.text" class="badge-icon">{{ badgeConfig.icon }}</mat-icon>
  <span *ngIf="badgeConfig.text" class="badge-text">{{ badgeConfig.text }}</span>
  <mat-icon *ngIf="hasPaymentIssue" class="payment-warning-icon">error</mat-icon>
</div>
